const ProfileSkeleton: React.FC = () => {
    return (
        <div className="flex flex-col w-full h-[100vh] overflow-y-auto side_bar bg-gray-50 animate-pulse">
            {/* Header */}
            <div className="h-16 bg-gray-200 rounded-md w-full mb-6"></div>

            <div className="flex-1 p-6">
                <div className="mx-auto">
                    {/* Top Buttons */}
                    <div className="flex justify-end mb-6 gap-2">
                        <div className="h-10 bg-gray-200 rounded-lg w-40"></div>
                        <div className="h-10 bg-gray-200 rounded-lg w-28"></div>
                    </div>

                    {/* Profile Header Card */}
                    <div className="bg-gray-100 rounded-lg shadow-sm p-6 mb-6">
                        <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-0 justify-between">
                            <div className="flex items-center space-x-4">
                                <div className="w-12 h-12 md:w-20 md:h-20 rounded-full bg-gray-200"></div>
                                <div>
                                    <div className="h-6 bg-gray-200 rounded w-48 mb-2"></div>
                                    <div className="h-4 bg-gray-200 rounded w-32 mb-2"></div>
                                    <div className="h-4 bg-gray-200 rounded w-24"></div>
                                </div>
                            </div>
                            <div className="flex gap-1 md:gap-3">
                                <div className="h-10 bg-gray-200 rounded-lg w-28"></div>
                                <div className="h-10 bg-gray-200 rounded-lg w-28"></div>
                                <div className="h-10 bg-gray-200 rounded-lg w-28"></div>
                            </div>
                        </div>
                    </div>

                    {/* Profile Details Card */}
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="h-6 bg-gray-200 rounded w-1/4 mb-6"></div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {Array.from({ length: 12 }).map((_, index) => (
                                <div key={index}>
                                    <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
                                    <div className="h-6 bg-gray-200 rounded w-full"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileSkeleton; 